import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { formatRelativeTime } from '../utils/time';
import './Messages.css';

interface ChatMessage {
  id: string;
  senderRole: 'user' | 'admin' | 'assistant';
  content: string;
  createdAt: string;
}

const Messages: React.FC = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await api.get('/chats/me');
        setMessages(response.data?.messages || []);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  return (
    <div className="container messages-page">
      <div className="messages-header">
        <h1>Message History</h1>
        <p>Review your conversation with Club Kazi support.</p>
      </div>

      <div className="messages-card">
        {loading ? (
          <div className="messages-loading">Loading messages...</div>
        ) : messages.length === 0 ? (
          <div className="messages-empty">
            <div className="messages-empty-icon">💬</div>
            <h2>No messages yet</h2>
            <p>When you contact support, your conversation will appear here.</p>
            <div className="messages-empty-actions">
              <Link to="/products" className="btn btn-primary">
                Start shopping
              </Link>
              <span className="messages-empty-note">Need help? Use the chat bubble on any page.</span>
            </div>
          </div>
        ) : (
          <div className="messages-list">
            {messages.map(message => (
              <div key={message.id} className={`message-row ${message.senderRole}`}>
                <div className="message-bubble">{message.content}</div>
                <div className="message-time">
                  {formatRelativeTime(message.createdAt)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Messages;
